import { concat, includes } from 'lodash';

export interface DocumentUploadResponse {
  currentDocumentEntries: Record<string, string>;
  onboardingStatus: string;
  onboardingWorkflow: string[];
  personId: string;
}

export enum DocumentListType {
  DocListA = 'DocListA',
  DocListB = 'DocListB',
  DocListC = 'DocListC'
}

export enum DocumentSide {
  Front,
  Back
}

export interface IDocumentFile {
  id: string;
  fileName: string;
  contentBase64: string;
  contentType: string;
}

export interface IDocument {
  isMainDocument: boolean;
  documentType: I9DocumentType;
  files: IDocumentFile[];
}

export enum I9DocumentType {
  I9 = 'I9',
  WOTC_8850 = 'WOTC_8850',
  WOTC_9061 = 'WOTC_9061',
  WOTC_9175 = 'WOTC_9175',
  ASSOCIATE_CONTRACT = 'ASSOCIATE_CONTRACT',
  ASSOCIATE_HANDBOOK = 'ASSOCIATE_HANDBOOK',
  ASSOCIATE_AT_WILL = 'ASSOCIATE_AT_WILL',
  PASSPORT = 'PASSPORT',
  PASSPORT_CARD = 'PASSPORT_CARD',
  PERM_RESIDENT_CARD_I_551 = 'PERM_RESIDENT_CARD_I_551',
  PERM_RESIDENT_CARD_I_551_BACK = 'PERM_RESIDENT_CARD_I_551_BACK',
  ALIEN_REG_RECEIPT_CARD_I_551 = 'ALIEN_REG_RECEIPT_CARD_I_551',
  ALIEN_REG_RECEIPT_CARD_I_551_BACK = 'ALIEN_REG_RECEIPT_CARD_I_551_BACK',
  FOREIGN_PASSPORT = 'FOREIGN_PASSPORT',
  I_551_STAMP = 'I_551_STAMP',
  FOREIGN_PASSPORT_MRIV = 'FOREIGN_PASSPORT_MRIV',
  I_551_PRINTED_NOTATION_MRIV = 'I_551_PRINTED_NOTATION_MRIV',
  I_766 = 'I_766',
  I_766_BACK = 'I_766_BACK',
  FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT = 'FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT',
  I_94 = 'I_94',
  I_94A = 'I_94A',
  I_20 = 'I_20',
  DS2019 = 'DS_2019',
  FSM_PASSPORT_I94 = 'FSM_PASSPORT_I94',
  RMI_PASSPORT_I94 = 'RMI_PASSPORT_I94',
  RECEIPT_FORM_I_94_I_94A_W_I_551_STAMP_PHOTO = 'RECEIPT_FORM_I_94_I_94A_W_I_551_STAMP_PHOTO',
  RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551 = 'RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551',
  RECEIPT_REPLACEMENT_EAD_FORM_I_766 = 'RECEIPT_REPLACEMENT_EAD_FORM_I_766',
  RECEIPT_FORM_I_94_I_94A_W_REFUGEE_STAMP_OR_RE_CLASS_OF_ADMISSION = 'RECEIPT_FORM_I_94_I_94A_W_REFUGEE_STAMP_OR_RE_CLASS_OF_ADMISSION',
  RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT = 'RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT',
  RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A = 'RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A',
  RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A = 'RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A',
  RECEIPT_FORM_I_94_I_94A = 'RECEIPT_FORM_I_94_I_94A',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  ID_CARD = 'ID_CARD',
  GOVERNMENT_ID = 'GOVERNMENT_ID',
  GOVERNMENT_ID_CARD = 'GOVERNMENT_ID_CARD',
  SCHOOL_ID = 'SCHOOL_ID',
  SCHOOL_ID_CARD = 'SCHOOL_ID_CARD',
  VOTER_S_REGISTRATION_CARD = 'VOTER_S_REGISTRATION_CARD',
  MILITARY_ID = 'MILITARY_ID',
  MILITARY_DRAFT_RECORD = 'MILITARY_DRAFT_RECORD',
  MILITARY_DEPENDENT_ID = 'MILITARY_DEPENDENT_ID',
  MARINER_CARD = 'MARINER_CARD',
  TRIBAL_DOCUMENT_B = 'TRIBAL_DOCUMENT_B',
  CANADIAN_DRIVERS_LICENSE = 'CANADIAN_DRIVERS_LICENSE',
  SPECIAL_PLACEMENT = 'SPECIAL_PLACEMENT',
  RECEIPT_REPLACEMENT_DRIVER_S_LICENSE = 'RECEIPT_REPLACEMENT_DRIVER_S_LICENSE',
  RECEIPT_REPLACEMENT_ID_CARD = 'RECEIPT_REPLACEMENT_ID_CARD',
  RECEIPT_REPLACEMENT_GOVERNMENT_ID_CARD = 'RECEIPT_REPLACEMENT_GOVERNMENT_ID_CARD',
  RECEIPT_REPLACEMENT_SCHOOL_ID_CARD = 'RECEIPT_REPLACEMENT_SCHOOL_ID_CARD',
  RECEIPT_REPLACEMENT_VOTER_REG_CARD = 'RECEIPT_REPLACEMENT_VOTER_REG_CARD',
  RECEIPT_REPLACEMENT_US_MILITARY_CARD = 'RECEIPT_REPLACEMENT_US_MILITARY_CARD',
  RECEIPT_REPLACEMENT_MILITARY_DRAFT_RECORD = 'RECEIPT_REPLACEMENT_MILITARY_DRAFT_RECORD',
  RECEIPT_REPLACEMENT_MILITARY_DEP_CARD = 'RECEIPT_REPLACEMENT_MILITARY_DEP_CARD',
  RECEIPT_REPLACEMENT_USCG_MERCHANT_MARINER_CARD = 'RECEIPT_REPLACEMENT_USCG_MERCHANT_MARINER_CARD',
  RECEIPT_REPLACEMENT_NATIVE_AMERICAN_TRIBAL_DOCUMENT = 'RECEIPT_REPLACEMENT_NATIVE_AMERICAN_TRIBAL_DOCUMENT',
  RECEIPT_REPLACEMENT_CANADIAN_DL = 'RECEIPT_REPLACEMENT_CANADIAN_DL',
  SOCIAL_SECURITY_CARD_UNRESTRICTED = 'SOCIAL_SECURITY_CARD_UNRESTRICTED',
  SOCIAL_SECURITY_CARD = 'SOCIAL_SECURITY_CARD',
  FS_545 = 'FS_545',
  DS_1350 = 'DS_1350',
  FS_240 = 'FS_240',
  US_BIRTH_CERTIFICATE = 'US_BIRTH_CERTIFICATE',
  TRIBAL_DOCUMENT_C = 'TRIBAL_DOCUMENT_C',
  I_197 = 'I_197',
  I_179 = 'I_179',
  EMPLOYMENT_AUTH_DOCUMENT_DHS_LIST_C_7 = 'EMPLOYMENT_AUTH_DOCUMENT_DHS_LIST_C_7',
  RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED = 'RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED',
  RECEIPT_REPLACEMENT_US_BIRTH_CERTIFICATE = 'RECEIPT_REPLACEMENT_US_BIRTH_CERTIFICATE',
  RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL_DOCUMENT = 'RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL_DOCUMENT',
  // RECEIPT_REPLACE_EMPLOYMENT_AUTH_DOC_DHS_LIST_C_7 = 'RECEIPT_REPLACE_EMPLOYMENT_AUTH_DOC_DHS_LIST_C_7',
  PASSPORT_CARD_BACK = 'PASSPORT_CARD_BACK',
  RECEIPT_LIST_A = 'RECEIPT_LIST_A',
  LETTER = 'LETTER',
  OTHER_LIST_A = 'OTHER_LIST_A',
  VOTER_REGISTRATION = 'VOTER_REGISTRATION',
  CLINIC_RECORD = 'CLINIC_RECORD',
  DOCTOR_RECORD = 'DOCTOR_RECORD',
  HOSPITAL_RECORD = 'HOSPITAL_RECORD',
  DAY_CARE_RECORD = 'DAY_CARE_RECORD',
  NURSERY_RECORD = 'NURSERY_RECORD',
  INDIVIDUAL_UNDER_18 = 'INDIVIDUAL_UNDER_18',
  OTHER_LIST_B = 'OTHER_LIST_B',
  OTHER_LIST_C = 'OTHER_LIST_C',
}

export const TwoSidedDocuments = [
  I9DocumentType.PASSPORT,
  I9DocumentType.PASSPORT_CARD,
  I9DocumentType.PERM_RESIDENT_CARD_I_551,
  I9DocumentType.ALIEN_REG_RECEIPT_CARD_I_551,
  I9DocumentType.I_766
];

// list A: requires two!
export const RequireTwoUploads = [
  I9DocumentType.FOREIGN_PASSPORT,
  I9DocumentType.FOREIGN_PASSPORT_MRIV,
  I9DocumentType.FSM_PASSPORT_I94,
  I9DocumentType.RMI_PASSPORT_I94,
  I9DocumentType.RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A,
  I9DocumentType.RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A,
  I9DocumentType.RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551
];

// list A: at least two and maybe 3.
export const Require2WithOption = [
  I9DocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT,
  I9DocumentType.RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT,
];

export const RequireMultipleUploads = RequireTwoUploads.concat(Require2WithOption);

export const SupportiveDocuments = [
  I9DocumentType.I_94,
  I9DocumentType.I_94A,
  I9DocumentType.RECEIPT_FORM_I_94_I_94A,
  I9DocumentType.I_20,
  I9DocumentType.DS2019,
  I9DocumentType.I_551_STAMP,
  I9DocumentType.I_551_PRINTED_NOTATION_MRIV
];

export const ListADocuments = [
  I9DocumentType.PASSPORT,
  I9DocumentType.PASSPORT_CARD,
  I9DocumentType.PASSPORT_CARD_BACK,
  I9DocumentType.PERM_RESIDENT_CARD_I_551,
  I9DocumentType.PERM_RESIDENT_CARD_I_551_BACK,
  I9DocumentType.ALIEN_REG_RECEIPT_CARD_I_551,
  I9DocumentType.ALIEN_REG_RECEIPT_CARD_I_551_BACK,
  I9DocumentType.FOREIGN_PASSPORT,
  I9DocumentType.I_551_STAMP,
  I9DocumentType.I_766,
  I9DocumentType.I_766_BACK,
  I9DocumentType.FOREIGN_PASSPORT_MRIV,
  I9DocumentType.I_551_PRINTED_NOTATION_MRIV,
  I9DocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT,
  I9DocumentType.I_20,
  I9DocumentType.I_94,
  I9DocumentType.I_94A,
  I9DocumentType.DS2019,
  I9DocumentType.FSM_PASSPORT_I94,
  I9DocumentType.RMI_PASSPORT_I94,
  I9DocumentType.RECEIPT_FORM_I_94_I_94A_W_I_551_STAMP_PHOTO,
  I9DocumentType.RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551,
  I9DocumentType.RECEIPT_REPLACEMENT_EAD_FORM_I_766,
  I9DocumentType.RECEIPT_FORM_I_94_I_94A_W_REFUGEE_STAMP_OR_RE_CLASS_OF_ADMISSION,
  I9DocumentType.RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT,
  I9DocumentType.RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A,
  I9DocumentType.RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A,
  I9DocumentType.RECEIPT_FORM_I_94_I_94A,
  I9DocumentType.RECEIPT_LIST_A,
  I9DocumentType.LETTER,
  I9DocumentType.OTHER_LIST_A,
];
export const ListBDocuments = [
  I9DocumentType.DRIVERS_LICENSE,
  I9DocumentType.ID_CARD,
  I9DocumentType.GOVERNMENT_ID_CARD,
  I9DocumentType.GOVERNMENT_ID,
  I9DocumentType.SCHOOL_ID_CARD,
  I9DocumentType.SCHOOL_ID,
  I9DocumentType.VOTER_S_REGISTRATION_CARD,
  I9DocumentType.MILITARY_ID,
  I9DocumentType.MILITARY_DRAFT_RECORD,
  I9DocumentType.MILITARY_DEPENDENT_ID,
  I9DocumentType.MARINER_CARD,
  I9DocumentType.TRIBAL_DOCUMENT_B,
  I9DocumentType.CANADIAN_DRIVERS_LICENSE,
  I9DocumentType.SPECIAL_PLACEMENT,
  I9DocumentType.RECEIPT_REPLACEMENT_DRIVER_S_LICENSE,
  I9DocumentType.RECEIPT_REPLACEMENT_ID_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_GOVERNMENT_ID_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_SCHOOL_ID_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_VOTER_REG_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_US_MILITARY_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_MILITARY_DRAFT_RECORD,
  I9DocumentType.RECEIPT_REPLACEMENT_MILITARY_DEP_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_USCG_MERCHANT_MARINER_CARD,
  I9DocumentType.RECEIPT_REPLACEMENT_NATIVE_AMERICAN_TRIBAL_DOCUMENT,
  I9DocumentType.RECEIPT_REPLACEMENT_CANADIAN_DL,
  I9DocumentType.HOSPITAL_RECORD,
  I9DocumentType.CLINIC_RECORD,
  I9DocumentType.DOCTOR_RECORD,
  I9DocumentType.VOTER_REGISTRATION,
  I9DocumentType.DAY_CARE_RECORD,
  I9DocumentType.NURSERY_RECORD,
  I9DocumentType.INDIVIDUAL_UNDER_18,
  I9DocumentType.OTHER_LIST_B,
];
export const ListCDocuments = [
  I9DocumentType.SOCIAL_SECURITY_CARD_UNRESTRICTED,
  I9DocumentType.SOCIAL_SECURITY_CARD,
  I9DocumentType.FS_545,
  I9DocumentType.DS_1350,
  I9DocumentType.FS_240,
  I9DocumentType.US_BIRTH_CERTIFICATE,
  I9DocumentType.TRIBAL_DOCUMENT_C,
  I9DocumentType.I_197,
  I9DocumentType.I_179,
  I9DocumentType.EMPLOYMENT_AUTH_DOCUMENT_DHS_LIST_C_7,
  I9DocumentType.RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED,
  I9DocumentType.RECEIPT_REPLACEMENT_US_BIRTH_CERTIFICATE,
  I9DocumentType.RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL_DOCUMENT,
  // I9DocumentType.RECEIPT_REPLACE_EMPLOYMENT_AUTH_DOC_DHS_LIST_C_7,
  I9DocumentType.OTHER_LIST_C,
];

export const I9Documents: I9DocumentType[] = concat(ListADocuments, ListBDocuments, ListCDocuments);

export const I9DocumentsByType = new Map([
  [DocumentListType.DocListA, ListADocuments],
  [DocumentListType.DocListB, ListBDocuments],
  [DocumentListType.DocListC, ListCDocuments],
])

export const getDocumentsByListType = (docListType: DocumentListType): I9DocumentType[] | undefined => {
  return I9DocumentsByType.get(docListType);
}

export const getDocumentListType = (document: I9DocumentType): DocumentListType => {
  if (I9DocumentsByType.get(DocumentListType.DocListA)?.includes(document)) return DocumentListType.DocListA;
  if (I9DocumentsByType.get(DocumentListType.DocListB)?.includes(document)) return DocumentListType.DocListB;
  if (I9DocumentsByType.get(DocumentListType.DocListC)?.includes(document)) return DocumentListType.DocListC;
  throw new Error(`Document: ${document} is not in List A, B or C`);
}

export const getDocumentsRequired = (
  documentType: I9DocumentType,
  documentsAdded: I9DocumentType[]
): I9DocumentType[] => {
  switch (documentType) {
    case I9DocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT:
    case I9DocumentType.FSM_PASSPORT_I94:
    case I9DocumentType.RMI_PASSPORT_I94:
      return [I9DocumentType.I_94, I9DocumentType.I_94A, I9DocumentType.RECEIPT_FORM_I_94_I_94A];
    case I9DocumentType.I_94:
    case I9DocumentType.I_94A:
    case I9DocumentType.RECEIPT_FORM_I_94_I_94A:
      const docTypeAcceptingI20Etc = [
        I9DocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT,
        I9DocumentType.RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT
      ];
      return includes(docTypeAcceptingI20Etc, documentsAdded[0]) ?
        [I9DocumentType.I_20, I9DocumentType.DS2019] : [];
    case I9DocumentType.RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT:
    case I9DocumentType.RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A:
    case I9DocumentType.RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A:
      return [I9DocumentType.I_94, I9DocumentType.I_94A, I9DocumentType.RECEIPT_FORM_I_94_I_94A];
    case I9DocumentType.FOREIGN_PASSPORT:
      return [I9DocumentType.I_551_STAMP];
    case I9DocumentType.FOREIGN_PASSPORT_MRIV:
      return [I9DocumentType.I_551_PRINTED_NOTATION_MRIV];
    case I9DocumentType.RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551:
      return [I9DocumentType.PERM_RESIDENT_CARD_I_551];
    default:
      return [];
  }
}

export enum WorkStatus {
  US_CITIZEN = 'US_CITIZEN',
  NON_CITIZEN_NATIONAL = 'NON_CITIZEN_NATIONAL',
  PERMANENT_RESIDENT = 'PERMANENT_RESIDENT',
  AUTHORIZED_ALIEN = 'AUTHORIZED_ALIEN'
}

export const DocumentsByWorkStatus = {
  [WorkStatus.US_CITIZEN]: [
    I9DocumentType.PASSPORT,
    I9DocumentType.PASSPORT_CARD,
    ...ListBDocuments,
    ...ListCDocuments
  ],
  [WorkStatus.NON_CITIZEN_NATIONAL]: [
    I9DocumentType.PASSPORT,
    I9DocumentType.PASSPORT_CARD,
    ...ListBDocuments,
    ...ListCDocuments
  ],
  [WorkStatus.PERMANENT_RESIDENT]: [
    I9DocumentType.PERM_RESIDENT_CARD_I_551,
    I9DocumentType.ALIEN_REG_RECEIPT_CARD_I_551,
    I9DocumentType.FOREIGN_PASSPORT,
    I9DocumentType.FOREIGN_PASSPORT_MRIV,
    I9DocumentType.RECEIPT_FORM_I_94_I_94A_W_I_551_STAMP_PHOTO,
    I9DocumentType.RECEIPT_REPLACEMENT_PERM_RES_CARD_FORM_I_551,
    ...ListBDocuments,
    I9DocumentType.SOCIAL_SECURITY_CARD_UNRESTRICTED,
    I9DocumentType.TRIBAL_DOCUMENT_C,
    I9DocumentType.EMPLOYMENT_AUTH_DOCUMENT_DHS_LIST_C_7,
    I9DocumentType.RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED,
    I9DocumentType.RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL_DOCUMENT,
    // I9DocumentType.RECEIPT_REPLACE_EMPLOYMENT_AUTH_DOC_DHS_LIST_C_7,
    ...SupportiveDocuments
  ],
  [WorkStatus.AUTHORIZED_ALIEN]: [
    I9DocumentType.I_766,
    I9DocumentType.FOREIGN_PASSPORT_WORK_AUTHORIZED_NON_IMMIGRANT,
    I9DocumentType.FSM_PASSPORT_I94,
    I9DocumentType.RMI_PASSPORT_I94,
    I9DocumentType.RECEIPT_REPLACEMENT_EAD_FORM_I_766,
    I9DocumentType.RECEIPT_FORM_I_94_I_94A_W_REFUGEE_STAMP_OR_RE_CLASS_OF_ADMISSION,
    I9DocumentType.RECEIPT_FOREIGN_PASSPORT_WORK_AUTHORIZED_NONIMMIGRANT,
    I9DocumentType.RECEIPT_FSM_PASSPORT_WITH_FORM_I_94_I_94A,
    I9DocumentType.RECEIPT_RMI_PASSPORT_WITH_FORM_I_94_I_94A,
    ...ListBDocuments,
    I9DocumentType.SOCIAL_SECURITY_CARD_UNRESTRICTED,
    I9DocumentType.TRIBAL_DOCUMENT_C,
    I9DocumentType.EMPLOYMENT_AUTH_DOCUMENT_DHS_LIST_C_7,
    I9DocumentType.RECEIPT_REPLACEMENT_SS_CARD_UNRESTRICTED,
    ...SupportiveDocuments
  ]
}



// WEBPACK FOOTER //
// ./src/models/onboarding-review/section2-document-upload.ts